export default class StyleManager {
    private styleData: any;

    public setStyleData(styleData: Object) {
        this.styleData = styleData;

        this.resolveInheritance(this.styleData);
    }

    public getStyle(key: string): any {
        if (this.styleData === undefined) {
            console.warn('Style data not found.');
            return;
        }

        const keys: Array<string> = key.split('.');
        return keys.reduce((accumulator: any, currentValue: any) => {
            if (accumulator[currentValue] === undefined) {
                console.warn(`Style key '${key}'not found`);
                return {};
            }
            return accumulator[currentValue]
        }, this.styleData);
    }

    /**
     * Check all (and sub) properties and if there is any _parent key merge
     * its parent style to the current one.
     * @param data 
     */
    private resolveInheritance(data: any) {
        if (typeof data === 'object') {
            const keys: Array<string> = Object.keys(data);
            keys.forEach(key => {
                data[key] = this.resolveInheritance(data[key]);
                if (key === '_parent') {
                    data = {
                        ...this.getStyle(data[key]),
                        ...data
                    }
                    delete data['_parent'];
                }
            });
        }
        return data;
    }
}
